/**
 * Scheduled jobs — mutation endpoints (the list itself flows through the
 * data provider). All calls carry the account-id header so the service scopes
 * them to the right tenant (schedules are tenant-owned).
 */

import { httpClient } from "@/utils/httpClient";

const accountHeader = (accountId: string): { headers: Record<string, string> } => ({
  headers: { "account-id": accountId },
});

export const deleteSchedule = async (
  accountId: string,
  scheduleId: string,
): Promise<void> => {
  await httpClient.delete(`/v1/schedules/${encodeURIComponent(scheduleId)}`, accountHeader(accountId));
};

/** Pause / resume — only valid for RECURRING schedules. */
export const setScheduleStatus = async (
  accountId: string,
  scheduleId: string,
  status: "PAUSED" | "ACTIVE",
): Promise<void> => {
  await httpClient.patch(
    `/v1/schedules/${encodeURIComponent(scheduleId)}/status`,
    { status },
    accountHeader(accountId),
  );
};

export interface RescheduleBody {
  datetime?: string;
  interval?: { value: number; unit: string };
  expiresAt?: string;
}

export const reschedule = async (
  accountId: string,
  scheduleId: string,
  body: RescheduleBody,
): Promise<void> => {
  await httpClient.patch(
    `/v1/schedules/${encodeURIComponent(scheduleId)}`,
    body,
    accountHeader(accountId),
  );
};
